// extracted by mini-css-extract-plugin
export default {"welcome":"welcome_welcome__enY01","overlay":"welcome_overlay__onEpx","info":"welcome_info__Nb8l7","hr":"welcome_hr__q32uH"};